/**
 * Video na pozadí hero sekce.
 *
 * Zdroj se do <source> doplní až tady, takže si ho prohlížeč nestáhne dřív,
 * než je jasné, že ho vůbec chce – a pod 1024 px si ho nestáhne vůbec. Do té
 * doby drží pozadí poster. Stejné chování má solpap (src/js/video.js), ať se
 * weby chovají stejně.
 */

const DESKTOP_FROM = 1024

export const initHeroVideo = () => {
    if (window.innerWidth < DESKTOP_FROM) return

    const video = document.querySelector('.js-hero-video-file')

    if (!video) return

    const sources = video.querySelectorAll('source[data-src]')

    if (!sources.length) return

    sources.forEach((source) => {
        source.src = source.dataset.src
    })

    video.load()
}
